// Horário oficial de Brasília sincronizado pela internet.
export const BR_TZ = 'America/Sao_Paulo';
let offsetMs = 0; // diferença entre relógio da internet e do aparelho

export async function syncInternetTime() {
  const sources: Array<() => Promise<number>> = [
    async () => {
      const r = await fetch('https://worldtimeapi.org/api/timezone/America/Sao_Paulo', { cache: 'no-store' });
      const j = await r.json();
      return new Date(j.utc_datetime).getTime();
    },
    async () => {
      const r = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/auth/v1/health`, { cache: 'no-store', headers: { apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY } });
      const d = r.headers.get('date');
      if (!d) throw new Error('sem data');
      return new Date(d).getTime();
    },
  ];
  for (const src of sources) {
    try {
      const t0 = Date.now();
      const server = await src();
      const t1 = Date.now();
      if (!isNaN(server)) { offsetMs = server - (t0 + t1) / 2; return; }
    } catch { /* tenta próxima */ }
  }
}

export const nowBR = () => new Date(Date.now() + offsetMs);

function parts(d: Date) {
  const p = new Intl.DateTimeFormat('en-CA', { timeZone: BR_TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(d);
  const g = (t: string) => p.find(x => x.type === t)?.value || '';
  return { date: `${g('year')}-${g('month')}-${g('day')}`, time: `${g('hour')}:${g('minute')}` };
}
/** Data (YYYY-MM-DD) em Brasília */
export const toBRDate = (d: Date = nowBR()) => parts(d).date;
export const todayBR = () => toBRDate();
export const timeBR = (d: Date = nowBR()) => parts(d).time;

/** Faz toLocaleString/DateString/TimeString usarem sempre o fuso de Brasília. */
export function installBrasiliaTimezone() {
  const P = Date.prototype as any;
  (['toLocaleString', 'toLocaleDateString', 'toLocaleTimeString'] as const).forEach((k) => {
    const orig = P[k];
    P[k] = function (locales?: any, opts?: Intl.DateTimeFormatOptions) {
      return orig.call(this, locales ?? 'pt-BR', { timeZone: BR_TZ, ...(opts || {}) });
    };
  });
  void syncInternetTime();
  setInterval(() => void syncInternetTime(), 30 * 60 * 1000);
}
